'use strict'

const { labeledUrl, accountOriginFromLabeledLocation } = require('./labeled-host')

const DESIGNER_LABEL = 'designer'

function designerUrl (accountOrigin, application) {

  return labeledUrl(DESIGNER_LABEL, accountOrigin, application)
}

function accountOriginFromLocation (location) {

  return accountOriginFromLabeledLocation(DESIGNER_LABEL, location)
}

function apiFromLocation (location, stored) {

  const fromHost = accountOriginFromLocation(location)

  if (fromHost) {

    return fromHost
  }

  const params = new URLSearchParams(location && location.search || '')
  const fromQuery = params.get('api')

  if (fromQuery) {

    return fromQuery
  }

  if (stored) {

    return stored
  }

  return 'http://localhost:9998'
}

module.exports = {
  designerUrl,
  accountOriginFromLocation,
  apiFromLocation
}
